import PortalRedirect from '../../components/portal/layout/portal-redirect.component';

// _app.tsx's `init()` bails out when `pageProps.url` is falsy. We still
// need this stub for the redirect chunk to hydrate, so keep the same
// SSG props pattern as the other portal pages.
export async function getStaticProps() {
    return {props: {url: '/portal/billing'}};
}

/**
 * Legacy redirect stub: `/portal/billing` → `/portal/plan` after the
 * Portal UX Overhaul Phase 3 consolidated the current-plan summary into
 * the new `/portal/plan` page.
 */
export default function BillingRedirect() {
    return <PortalRedirect to="/portal/plan" />;
}
